import routes from './router/Index';
import { RouterProvider } from 'react-router-dom';
import './assets/libs/morris.js/morris.css';
import './assets/css/style.min.css';
import './assets/css/icons.min.css';
import './index.css';

function App() {
  return (
    <RouterProvider router={routes}/>
  );
}

export default App;
